import image from "src/assets/images/defaultTeam.png"

export const defaultTeam = image
